import {
  REGISTRATION_STEP_PATHS,
  RegistrationSteps,
} from "./routing-constants";

export const STEP_FIELDS: Record<RegistrationSteps, string[]> = {
  [REGISTRATION_STEP_PATHS.name]: ["firstName", "lastName"],
  [REGISTRATION_STEP_PATHS.phone]: ["country", "state", "phone"],
  [REGISTRATION_STEP_PATHS.accountType]: ["investorType"],
  [REGISTRATION_STEP_PATHS.entityInfo]: [
    "entityName",
    "entityCountry",
    "entityState",
  ],
};

export const ALL_REGISTRATION_FIELD_NAMES = Object.values(STEP_FIELDS).flat();

export const INVESTOR_TYPES = {
  INDIVIDUAL: "individual",
  ENTITY: "entity",
} as const;

export const VALID_INVESTOR_TYPES = Object.values(INVESTOR_TYPES);
